module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAAOElEQVQ4jWP8////fwZMwIhFjGjARInmoW8oCxXMwIiToeP9oWMoMRFFcuYYOt4fNXTU0FFDqQkAtB8GLLbGANsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_listen01.png
// module id = POpQ
// module chunks = 1